var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.useBoxedWidth ? 'container p-0' : 'layout-full-bleed'},[_c('transition',{attrs:{"name":"page-fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.meta.layoutKey || _vm.$route.path})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }